import {RegistrationFields} from "./../containers/RegistrationLoginPage/types";
import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "redux-thunk";
import {RootStore} from "../configureStore";
import {useForm} from "react-final-form";
import {
    SignUpActions,
    UserExamStatusSelectedValue,
} from "../containers/RegistrationLoginPage/types";
import {
    setExamStatusDependentData,
    setExamStatusDependentLoadingState,
    setExamStatusDependentVisibility,
} from "../containers/RegistrationLoginPage/actions";
import {isMMPType} from "../components/CTA/response";

const useExamStatusHandler = (): ((examStatus: UserExamStatusSelectedValue) => void) => {
    const dispatch = useDispatch<ThunkDispatch<RootStore, undefined, SignUpActions>>();

    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);

    const bachelorFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields,
    );

    const masterFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.masterFields,
    );

    const phdFields = useSelector((state: RootStore) => state.RegistrationLoginPage.phdFields);

    const passport = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData?.fields?.passport,
    );

    const trackingKey = useSelector((state: RootStore) => state.RegistrationLoginPage.trackingKey);

    const ctaTrackingData = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.ctaTrackingData,
    );

    const examStatusPromiseCancel = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.examStatusPromiseCancel,
    );

    const universityId = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.universityId,
    );

    let courseId = useSelector((state: RootStore) => state.RegistrationLoginPage.courseId);

    const form = useForm<RegistrationFields>();

    if (!courseId) {
        const {values} = form.getState();
        courseId = values.course ? values.course.id : undefined;
    }

    return useCallback(
        (examStatus: UserExamStatusSelectedValue) => {
            if (examStatusPromiseCancel) {
                examStatusPromiseCancel();
            }

            if (level !== null && level !== undefined) {
                // reset fields in react-final-form
                const fieldToReset = ["examScore", "passport"];
                const registeredFields = form.getRegisteredFields() as [keyof RegistrationFields];
                registeredFields.map((registeredField) => {
                    fieldToReset.map((field) => {
                        if (registeredField.includes(field)) {
                            form.resetFieldState(registeredField);
                            form.change(registeredField, undefined);
                        }
                    });
                });

                const visibility =
                    examStatus === "given"
                        ? {
                              passport: true,
                              examScore: true,
                          }
                        : examStatus === "not_given"
                        ? {
                              passport: true,
                              examScore: false,
                          }
                        : {
                              passport: true,
                              examScore: false,
                          };
                // update redux to maintain visibility of exam score and passport field on change of exam status
                dispatch(
                    setExamStatusDependentVisibility({
                        ...visibility,
                        level: level,
                    }),
                );

                // conditional api call to fetch exam status and passport data
                if (
                    (examStatus === "given" &&
                        ((level === "Bachelors" && !bachelorFields?.examScore?.values) ||
                            (level === "Masters" && !masterFields?.examScore?.values) ||
                            (level === "PhD" && !phdFields?.examScore?.values))) ||
                    (examStatus === "not_given" && passport?.values === null)
                ) {
                    // set loading state
                    dispatch(setExamStatusDependentLoadingState(examStatus));
                    // fetch data
                    dispatch(
                        setExamStatusDependentData({
                            level: level,
                            trackingId: trackingKey,
                            examStatus: examStatus,
                            universityId: universityId,
                            courseId: courseId,
                            mmpId:
                                ctaTrackingData && isMMPType(ctaTrackingData)
                                    ? ctaTrackingData.mmpId
                                    : undefined,
                        }),
                    );
                }
            }
        },
        [
            level,
            ctaTrackingData,
            passport,
            bachelorFields,
            masterFields,
            phdFields,
            trackingKey,
            dispatch,
            examStatusPromiseCancel,
            form,
            courseId,
            universityId,
        ],
    );
};

export default useExamStatusHandler;
